import { Module } from '../Module';
import { IPosition, IStackedElement, StackedElementsService } from '../services/StackedElementsService';

export interface IStackedElementScope extends ng.IScope {
  stackedElement: IStackedElement;
  left?: number;
  top?: number;
  right?: number;
  bottom?: number;
  visible: boolean;
  overflowY?: string;
}

Module.instance().directive('tbStackedElement', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'inline_stackedElement.html',
      scope: {
        stackedElement: '='
      },
      link: (scope: IStackedElementScope, element: JQuery) => {
        const stackedElement = scope.stackedElement;
        element.html('').append(stackedElement.contentElement);

        if (stackedElement.setScope) stackedElement.setScope(scope);

        scope.$watch(() => stackedElement.getContentElementPosition(), (position: IPosition) => {
          scope.left = position.left;
          scope.top = position.top;
          scope.right = position.right;
          scope.bottom = position.bottom;
          scope.visible = true;
          scope.overflowY = 'visible';
          if (scope.top != null && scope.bottom != null) {
            scope.overflowY = 'auto';
            setTimeout(() => {
              element.scrollTop(0);
            });
          }
        }, true);

        element.on('$destroy', () => stackedElement.destroy && stackedElement.destroy());
      }
    };
  }
]);

interface IStackedElementsScope extends ng.IScope {
  stackedElements: IStackedElement[];
}

Module.instance().directive('tbStackedElements', <any[]>[
  'StackedElementsService',
  (StackedElementsService: StackedElementsService) => {
    return {
      restrict: 'E',
      replace: true,
      template: '<tb:stacked-element ng-repeat="stackedElement in stackedElements" stacked-element="stackedElement"></tb:stacked-element>',
      link: (scope: IStackedElementsScope, element: JQuery) => {
        scope.stackedElements = StackedElementsService.stackedElements;
      }
    };
  }
]);
